import ReactDOM from 'react-dom'
import './index.css'
import React from 'react'
import * as serviceWorker from './serviceWorker'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom'

ReactDOM.render(<Router><App /></Router>, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
